






import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator'

const componentName: string = 'CScore'
@Component({
  name: `${componentName}`
})
export default class UiComponent extends Mixins() {
  @Prop({ default: '' }) public score!: string
}
Vue.component(componentName, UiComponent)
